import React from 'react';
import { connect } from 'react-redux';
import { Table, Container, Row, Col, Input } from 'reactstrap';
import i18n from "../../../i18next";
import Pagination from 'react-js-pagination';

import { loadRefundSearch } from '../../../actions/restaurants/customerInsight/CustomerInsightAction';
import { getPriceWithCurrencySymbol } from '../../../utils/CommonUtils';
import { DEFAULT_PAGE_SIZE, DEFAULT_PAGING_RANGE } from "../../../utils/Constants";
import CustomerInsightSearchOptions from './CustomerInsightSearchOptions';

class RefundSearch extends React.Component {

    state = {
        fromDate: '',
        toDate: '',
        page: 0,
        amount: '',
        orderId: ''
    }

    componentDidMount() {
        const { restaurantId, customerId } = this.props;
        this.props.loadRefundSearch(restaurantId, customerId, this.state.page, this.state.fromDate, this.state.toDate,
            this.state.amount, this.state.orderId);
    }

    takeSearchOptionState = searchOptionState => {
        const { restaurantId, customerId } = this.props;
        this.setState({
            fromDate: searchOptionState.fromDate,
            toDate: searchOptionState.toDate,
            page: 0
        }, () => this.props.loadRefundSearch(restaurantId, customerId, this.state.page,
            this.state.fromDate, this.state.toDate, this.state.amount, this.state.orderId));
    }

    handlePageChange = pageNumber => {
        console.log(pageNumber)
        const { restaurantId, customerId } = this.props;
        this.setState({
            page: (pageNumber - 1)
        }, () => this.props.loadRefundSearch(restaurantId, customerId, this.state.page,
            this.state.fromDate, this.state.toDate, this.state.amount, this.state.orderId));
    }

    renderRefundTable = () => {
        return (
            <Table bordered hover style={{ marginTop: '25px' }}>
                <thead>
                    {this.renderTableHeaders()}
                </thead>
                <tbody>
                    {this.renderTableContent()}
                </tbody>
            </Table>
        );
    }

    renderTableHeaders = () => {

        const { tableHeaders, textCenter, textRight } = styles;

        return (
            <tr>
                <th style={{ ...tableHeaders }}>{i18n.t('screens:customerInsightScreen.orderId')}</th>
                <th style={{ ...tableHeaders }}>{i18n.t('screens:customerInsightScreen.reason')}</th>
                <th style={{ ...tableHeaders, ...textCenter }}>{i18n.t('screens:customerInsightScreen.date')}</th>
                <th style={{ ...tableHeaders, ...textRight }}>{i18n.t('screens:customerInsightScreen.amount')}</th>
                <th style={{ ...tableHeaders, ...textRight }}>{i18n.t(`screens:orderDetailsScreen.refundType`)}</th>
            </tr>
        );
    }

    renderTableContent = () => {
        return this.props.customerInsightRefundSearch.content.map(item => {
            return this.renderSingleItem(item);
        })
    }

    renderSingleItem = item => {

        const { tableDetail, firstRow, textCenter, textRight } = styles;
        const currency = this.props.restaurant.currency;
        let refundType = item.refundType.replace(/_/g, ' ');
        
        return (
            <tr>
                <td style={{ ...tableDetail }}>{item.orderId}</td>
                <td style={{ ...tableDetail }}>{item.reason}</td>
                <td style={{ ...tableDetail, ...textCenter }}>{item.date}</td>
                <td style={{ ...tableDetail, ...textRight }}>{getPriceWithCurrencySymbol(item.refundAmount, currency)}</td>
                <td style={{ ...tableDetail, ...textRight }}>{refundType}</td>
            </tr>
        );
    }

    renderAdditionalSearchOptions = () => {

        return (
            <Container fluid>
                <Row>
                    {this.renderOrderIdInput()}
                    {this.renderAmountInput()}
                </Row>
            </Container>
        );
    }

    renderOrderIdInput = () => {
        return (
            <Col sm={3} style={{ paddingLeft: 0 }} >
                <Input
                    type="text"
                    name="orderId"
                    id="orderId"
                    placeholder={i18n.t('screens:customerInsightScreen.orderId')}
                    onChange={(e) => this.setState({ orderId: e.target.value })}
                    value={this.state.orderId}
                />
            </ Col>
        );
    }

    renderAmountInput = () => {
        return (
            <Col sm={3} style={{ paddingLeft: 0 }} >
                <Input
                    type="text"
                    name="amount"
                    id="amount"
                    placeholder={i18n.t('screens:customerInsightScreen.amount')}
                    onChange={(e) => this.setState({ amount: e.target.value })}
                    value={this.state.amount}
                />
            </ Col>
        );
    }

    renderPagination() {
        const { flexEnd } = styles;

        return (
            <Container>
                <Row>
                    <Col style={flexEnd}>
                        <Pagination
                            activePage={this.props.customerInsightRefundSearch.number + 1}
                            itemsCountPerPage={DEFAULT_PAGE_SIZE}
                            totalItemsCount={this.props.customerInsightRefundSearch.totalElements}
                            pageRangeDisplayed={DEFAULT_PAGING_RANGE}
                            itemClass='page-item'
                            linkClass='page-link'
                            onChange={this.handlePageChange}
                        />
                    </Col>
                </Row>
            </Container>
        );
    }

    render() {
        return (
            <React.Fragment>
                <CustomerInsightSearchOptions type="RefundSearch" takeSearchOptionState={this.takeSearchOptionState} />
                {this.renderAdditionalSearchOptions()}
                {this.renderRefundTable()}
                {this.renderPagination()}
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        customerInsightRefundSearch: state.customerInsightRefundSearch,
        restaurant: state.restaurant
    }
};

export default connect(mapStateToProps, { loadRefundSearch })(RefundSearch);

const styles = {
    tableHeaders: {
        padding: '10px',
        fontSize: '16px',
        fontWeight: 'bold',
    },
    tableDetail: {
        padding: '10px',
        fontSize: '14px',   //previously it was 14px not bolded
        fontWeight: 'bold',
    },
    firstRow: {
        //whiteSpace: 'nowrap'
        paddingRight: '0'
    },
    textCenter: {
        textAlign: 'center',
        padding: '10px 5px'
    },
    textRight: {
        textAlign: 'right',
        paddingLeft: '0'
    },
    flexEnd: {
        marginTop: '15px',
        display: 'flex',
        justifyContent: 'flex-end',
        paddingRight: 0
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/customerInsightScreen/RefundSearch.js